module.exports = {
      id: "astrology-usage",
      viewBox: "0 0 29.4 29.4",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#astrology",
      toString: function () {
        return this.url;
      }
    }